<script setup lang="ts"></script>

<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.2071 5.29289C13.8166 4.90237 13.1834 4.90237 12.7929 5.29289C12.4024 5.68342 12.4024 6.31658 12.7929 6.70711L17.0858 11H4.5C3.94772 11 3.5 11.4477 3.5 12C3.5 12.5523 3.94772 13 4.5 13H17.0858L12.7929 17.2929C12.4024 17.6834 12.4024 18.3166 12.7929 18.7071C13.1834 19.0976 13.8166 19.0976 14.2071 18.7071L19.5 13.4142C20.281 12.6332 20.281 11.3668 19.5 10.5858L14.2071 5.29289Z"
      fill="currentColor"
    />
  </svg>
</template>
